import {deepdash, observer, React} from '@api'
import {LayoutStore, SplitterNode, Tab, TabFloating, TabNode, useLayoutStore} from '@flexlayout'
import {computed, observable, trace} from 'mobx'
import {Fragment, ReactChild, useEffect} from 'react'
import {useUnmount} from 'react-use'

/// region Store

export class TabsStore {
  constructor(public store: LayoutStore) {
  }
  //
  // get borderTabs(): TabNode[] {
  //   const {store: {modelsupportsPopout, props: {model: {borderSet}}}} = this
  //   const tabs = _.flatMap(borderSet.borders.filter(b => b.isShowing).map(({drawChildren}) => drawChildren.filter(child => child instanceof TabNode))) as TabNode[]
  //   return tabs
  // }
  //
  // @computed get mainTabs() {
  //   const {store: {model: {root}}} = this
  //
  //   return deepdash.filterDeep(root.drawChildren, (value, key, parent) => {
  //     return parent instanceof TabNode
  //   })
  // }

  @computed get tabsDict() {
    const {store: {model: {_idMap}}} = this

    return _.keyBy(_.values(_idMap).filter(v => v instanceof TabNode) as TabNode[], t => t.id)
  }

  @computed get tabs(): TabNode[] {
    return _.values(this.tabsDict)
  }
}

/// endregion

/// region Components

export const Tabs = observer(function Tabs() {
  const store = useLayoutStore(),
    {visibleTabs, model: {flexLayout: { maximizedTab}}, supportsPopout, props: {factory}} = store

  // useEffect(() => {
  //   return () => console.log(`unmount Tabs`)
  // }, [])

  return (<Fragment>
    {(maximizedTab ? [maximizedTab] : visibleTabs).map(child => supportsPopout && child.isFloating
                  ? <TabFloating key={child.id} layout={store} node={child} selected={child.isSelected}/>
                  : <Tab key={child.id} layout={store} node={child} selected={child.isSelected} factory={factory}/>)}
  </Fragment>)
})



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexlayout-react/src/view/Layout/Tabs.tsx